import React, { useState } from "react";
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelFilter from "../../../shares/PanelFilter";
import { useNavigate } from "react-router-dom";
import MuiButton from "../../../shares/MuiButton";
import PrintIcon from "@mui/icons-material/Print";
import PanelTable from "../../../shares/PanelTable";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand", name: "برند" },
  { colName: "size_one_num", name: "سایز ۱" },
  { colName: "size_two_num", name: "سایز ۲" },
  { colName: "size_three_num", name: "سایز ۳" },
  { colName: "size_four_num", name: "سایز ۴" },
  { colName: "size_five_num", name: "سایز ۵" },
  { colName: "size_six_num", name: "سایز ۶" },
  { colName: "sum", name: "جمع" },
];

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand", name: "برند" },
];

const dataKey = [
  "code",
  "show_name",
  "gender",
  "color",
  "brand",
  "object.sold_nums.size_one_num",
  "object.sold_nums.size_two_num",
  "object.sold_nums.size_three_num",
  "object.sold_nums.size_four_num",
  "object.sold_nums.size_five_num",
  "object.sold_nums.size_six_num",
  "object.sold_nums.sum_bangle",
];

const AdminReportsSoldBangle = () => {
  const [codeFilter, setCodeFilter] = useState(null);
  const navigate = useNavigate();

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getRequestListApi.reFetch();
  };

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const [requestList, setRequestList] = useState([]);

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      code: fixNumbers(codeFilter),
    },
    url: `Order_Service/get_bangle_sold_log`,
    trigger: true,
    setter: setRequestList,
    argFunc: (res) => {},
    errMessage: (mess) => {},
  });

  const handelPrintReport = () => {
    navigate(`/print-report-bangle-sold-info/${codeFilter}`);
  };

  const buttonsList = [];

  const actionsList = [];

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-bangle-sold">
        <>
          <div className="panel-main-header">
            <span>اطلاعات کلی النگوهای فروخته شده</span>
          </div>
          <PanelFilter
            header="فیلتر :"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست النگوهای فروخته شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={requestList}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AddShoppingCartIcon />}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default AdminReportsSoldBangle;
